export const translations = {
  nl: {
    // Navigation
    nav: {
      home: "Home",
      werkwijze: "Werkwijze",
      overMij: "Over mij",
      diensten: "Diensten",
      audits: "Audits",
      pakketten: "Pakketten",
      blog: "Blog",
      contact: "Contact",
      quickScan: "Plan je Intake"
    },
    // Hero Section
    hero: {
      title: "FREELANCE SEO CONSULTANT",
      subtitle: "Holistische SEO consultancy door Falco Keiman. Ik help bedrijven in Nederland met meetbare organische groei via strategische sprints.",
      cta: "Plan je Intake Call",
      ctaSecondary: "Bekijk werkwijze"
    },
    // Services
    services: {
      title: "DIENSTEN",
      subtitle: "Van technische optimalisatie tot content strategie",
      seoTekstschrijver: {
        title: "SEO Tekstschrijver",
        description: "Converterende content die rankt"
      },
      linkbuilding: {
        title: "Linkbuilding",
        description: "Kwalitatieve backlinks bouwen"
      },
      localSeo: {
        title: "Local SEO",
        description: "Lokaal vindbaar worden"
      },
      migratie: {
        title: "Migratie",
        description: "Veilig verhuizen zonder traffic verlies"
      }
    },
    // Audits
    audits: {
      title: "AUDITS",
      subtitle: "Diepgaande analyses voor strategische inzichten",
      linkbuilding: {
        title: "Linkbuilding Audit",
        description: "Analyse van je backlinkprofiel"
      },
      contentPerformance: {
        title: "Content Performance",
        description: "Content gap en kansen analyse"
      },
      fullScope: {
        title: "Full Scope Audit",
        description: "Complete SEO doorlichting"
      },
      trafficRecovery: {
        title: "Traffic Recovery",
        description: "Herstel na Google update of penalty"
      }
    },
    // Packages
    packages: {
      title: "PAKKETTEN",
      subtitle: "Dezelfde holistische aanpak, verschil zit in snelheid en capaciteit. Kies je groeitempo.",
      setupFee: "Eenmalige SEO Launchpad (Setup Fee): €950",
      foundation: {
        name: "Foundation",
        price: "€850 p/m",
        quarterPrice: "€2.550 per kwartaal",
        velocity: "Stable Velocity",
        description: "Strategische regie en technische integriteit voor lokale specialisten",
        features: [
          "Technische SEO audit",
          "Strategische keyword-mapping",
          "Maandelijkse monitoring",
          "Real-time Master Document",
          "Quarterly Impact Report"
        ]
      },
      growth: {
        name: "Growth",
        price: "€1.250 p/m",
        quarterPrice: "€3.750 per kwartaal",
        velocity: "High Velocity",
        description: "Marktaandeel veroveren en autoriteit bouwen voor groeiende bedrijven",
        features: [
          "Alles van Foundation",
          "Content-cluster optimalisatie",
          "Linkbuilding management",
          "Content Pruning",
          "Bi-weekly Strategy Calls"
        ]
      },
      scale: {
        name: "Scale",
        price: "€1.950 p/m",
        quarterPrice: "€5.850 per kwartaal",
        velocity: "Maximum Velocity",
        description: "Maximale executiekracht voor complexe markten of volledige ontzorging",
        features: [
          "Alles van Growth",
          "Volledige ontzorging mogelijk",
          "AI-search visibility (GEO)",
          "Priority Support",
          "Advanced Competitor Analysis"
        ]
      },
      disclaimer: "Kosten voor Authority (linkbuilding) en Content Execution (externe copywriters) worden 1-op-1 doorgezet.",
      cta: "Plan je Intake Call"
    },
    // Werkwijze
    werkwijze: {
      title: "WERKWIJZE",
      subtitle: "Een gestructureerd 6-stappen proces",
      sprint: {
        title: "3-Maanden Trajecten",
        description: "SEO heeft tijd nodig. Een kwartaal is de minimale periode om significante trends te zien en ROI te bewijzen."
      },
      evaluation: {
        title: "Week 8 Evaluatie",
        description: "In week 8 van elke sprint volgt een verplichte evaluatie met nieuw strategisch advies en offerte voor de volgende periode."
      },
      document: {
        title: "Master Document",
        description: "Alle taken worden bijgehouden in een live document met kolommen: Omschrijving, Pijler, Categorie, Context, Status, Huidige situatie, Nieuwe situatie, Acties."
      },
      pillars: {
        title: "De 3 Pijlers",
        tech: {
          title: "Tech",
          description: "Technische SEO optimalisatie"
        },
        content: {
          title: "Content",
          description: "Content strategie en creatie"
        },
        authority: {
          title: "Authority",
          description: "Linkbuilding en autoriteit"
        }
      }
    },
    // About
    about: {
      title: "OVER MIJ",
      name: "Falco Keiman",
      role: "Freelance SEO Specialist sinds 2014",
      experience: "Ervaring bij Trivago, Alpina, Artefact, Yellowgrape",
      bio: "Mijn carrière in digital marketing begon tijdens mijn International Business studie. Bij Trivago maakte ik mijn eerste stappen in SEO. Sindsdien heb ik me ontwikkeld van een Off-page specialist tot een holistische SEO specialist die begrijpt dat echte groei ontstaat op het snijvlak van tech, content en authority.",
      cta: "Plan een gesprek"
    },
    // Contact
    contact: {
      title: "CONTACT",
      subtitle: "Klaar om je organische groeimotor te starten?",
      form: {
        name: "Naam",
        email: "E-mail",
        company: "Bedrijf",
        phone: "Telefoon",
        website: "Website",
        message: "Bericht",
        submit: "Verstuur",
        success: "Bedankt! Je bericht is verzonden.",
        error: "Er ging iets mis. Probeer het opnieuw."
      }
    },
    // Quick Scan Form -> Now Intake
    quickScan: {
      title: "PLAN JE INTAKE CALL",
      subtitle: "Laten we in 30 minuten bepalen welke velocity jouw bedrijf nodig heeft",
      form: {
        name: "Naam",
        email: "E-mail",
        company: "Bedrijf",
        website: "Website URL",
        phone: "Telefoon (optioneel)",
        message: "Vertel kort over je doelen",
        submit: "Plan je Intake",
        success: "Bedankt! Ik neem binnen 24 uur contact op.",
        error: "Er ging iets mis. Probeer het opnieuw."
      }
    },
    // Footer
    footer: {
      tagline: "Freelance SEO Specialist Nederland",
      quickLinks: "Snelle Links",
      contact: "Contact",
      email: "info@kesult.com",
      copyright: "© 2026 Kesult. Alle rechten voorbehouden."
    },
    // SEO Specialist Pages
    seoConsultant: {
      locationTitle: "Freelance SEO Specialist",
      sectorTitle: "SEO voor",
      challenge: "De Uitdaging",
      geoAdvantage: "GEO & AI Voordeel",
      geoDescription: "Ik optimaliseer voor Answer Engines zoals ChatGPT en Perplexity zodat jouw merk wordt geciteerd als de top expert.",
      pillars: "De 3 Pijlers",
      cta: "Plan je Intake Call"
    },
    // Decision Tree
    decisionTree: {
      title: "WELK PAKKET PAST BIJ JOU?",
      start: "Start",
      question1: "Heb je interne resources (developers/schrijvers)?",
      question2: "Hoe complex is je markt?",
      yes: "Ja",
      no: "Nee",
      simple: "Lokaal/Niche",
      medium: "Regionaal",
      complex: "Nationaal/Competitief",
      result: "Aanbevolen pakket:",
      restart: "Opnieuw beginnen"
    },
    // Blog
    blog: {
      title: "BLOG & CASES",
      subtitle: "Inzichten en succesverhalen",
      readMore: "Lees meer",
      back: "Terug naar overzicht"
    },
    // Common
    common: {
      learnMore: "Meer informatie",
      getStarted: "Aan de slag",
      viewAll: "Bekijk alles",
      loading: "Laden...",
      vanaf: "Vanaf",
      perMonth: "p/m",
      perQuarter: "per kwartaal"
    },
    // ROI Section
    roi: {
      title: "SEO vs. Google Ads",
      subtitle: "SEO is geen kostenpost, maar een investering",
      points: [
        "Bezit vs. Huur: Bij Ads 'huur' je bezoekers. Met SEO bouw je een eigen kanaal.",
        "80% van de zoekers klikt liever op organische resultaten dan advertenties.",
        "5.000 extra organische bezoekers bij €2 CPC = €10.000 advertentiewaarde per maand."
      ]
    }
  },
  en: {
    // Navigation
    nav: {
      home: "Home",
      werkwijze: "How I Work",
      overMij: "About",
      diensten: "SEO Services",
      audits: "Audits",
      pakketten: "Packages",
      blog: "Blog",
      contact: "Contact",
      quickScan: "Book Intake"
    },
    // Hero Section
    hero: {
      title: "YOUR SEO PARTNER IN THE NETHERLANDS",
      subtitle: "Expanding to the Dutch market? I help international businesses gain organic visibility in the Netherlands. From local keyword research to technical localisation — I bridge the gap between your brand and the Dutch consumer.",
      cta: "Book your Intake Call",
      ctaSecondary: "How I work"
    },
    // Services
    services: {
      title: "SEO SERVICES",
      subtitle: "Everything you need to rank in the Dutch market",
      seoTekstschrijver: {
        title: "Dutch SEO Content",
        description: "Native Dutch content that ranks on Google.nl"
      },
      linkbuilding: {
        title: "Dutch Link Building",
        description: "Quality backlinks from Dutch authority domains"
      },
      localSeo: {
        title: "Local SEO Netherlands",
        description: "Get found in Dutch cities and regions"
      },
      migratie: {
        title: "International Migration",
        description: "Launch your .nl domain without losing traffic"
      }
    },
    // Audits
    audits: {
      title: "AUDITS",
      subtitle: "Understand the Dutch search landscape before you invest",
      linkbuilding: {
        title: "Dutch Link Profile Audit",
        description: "Analysis of your Dutch backlink opportunities"
      },
      contentPerformance: {
        title: "Content Gap Analysis",
        description: "Find untapped Dutch keyword opportunities"
      },
      fullScope: {
        title: "Dutch Market SEO Audit",
        description: "Complete SEO review for the Netherlands"
      },
      trafficRecovery: {
        title: "Traffic Recovery",
        description: "Recovery after Google update or penalty"
      }
    },
    // Packages
    packages: {
      title: "PACKAGES",
      subtitle: "The same holistic approach for your Dutch market entry. The difference is in speed and capacity.",
      setupFee: "One-time SEO Launchpad (Setup Fee): €950",
      foundation: {
        name: "Foundation",
        price: "€850/month",
        quarterPrice: "€2,550 per quarter",
        velocity: "Stable Velocity",
        description: "Strategic direction and technical foundation for your Dutch market entry",
        features: [
          "Technical SEO audit",
          "Dutch keyword research",
          "Monthly monitoring",
          "Real-time Master Document",
          "Quarterly Impact Report"
        ]
      },
      growth: {
        name: "Growth",
        price: "€1,250/month",
        quarterPrice: "€3,750 per quarter",
        velocity: "High Velocity",
        description: "Accelerate your Dutch market share with content and authority building",
        features: [
          "Everything in Foundation",
          "Dutch content cluster strategy",
          "Dutch link building",
          "Content localisation",
          "Bi-weekly Strategy Calls"
        ]
      },
      scale: {
        name: "Scale",
        price: "€1,950/month",
        quarterPrice: "€5,850 per quarter",
        velocity: "Maximum Velocity",
        description: "Maximum execution power for competitive Dutch markets",
        features: [
          "Everything in Growth",
          "Full service option",
          "AI-search visibility (GEO)",
          "Priority Support",
          "Advanced Dutch competitor analysis"
        ]
      },
      disclaimer: "Costs for Authority (link building) and Content Execution (native Dutch copywriters) are passed through at cost.",
      cta: "Book your Intake Call"
    },
    // Werkwijze
    werkwijze: {
      title: "HOW I WORK",
      subtitle: "A structured approach to your Dutch market entry",
      sprint: {
        title: "3-Month Strategic Sprints",
        description: "Entering a new market takes time. A quarter is the minimum period to see significant trends and prove ROI in the Netherlands."
      },
      evaluation: {
        title: "Week 8 Evaluation",
        description: "In week 8 of every sprint, a mandatory evaluation with new strategic advice and proposal for the next period."
      },
      document: {
        title: "Master Document",
        description: "All tasks are tracked in a live document with columns: Description, Pillar, Category, Context, Status, Current situation, New situation, Actions."
      },
      pillars: {
        title: "The 3 Pillars",
        tech: {
          title: "Technical Excellence",
          description: "Technical SEO & localisation"
        },
        content: {
          title: "Content",
          description: "Dutch content strategy"
        },
        authority: {
          title: "Authority",
          description: "Dutch link building & PR"
        }
      }
    },
    // About
    about: {
      title: "ABOUT",
      name: "Falco Keiman",
      role: "Freelance SEO Specialist since 2014",
      experience: "International experience at Trivago, Alpina, Artefact, Yellowgrape",
      bio: "My career in digital marketing started during my International Business studies. At Trivago I gained hands-on experience with international SEO across multiple markets. Since then I've evolved into a holistic SEO specialist who understands what it takes to enter and compete in the Dutch search landscape. I help international businesses navigate the nuances of the Dutch market — from search behaviour and language to local link building and technical localisation.",
      cta: "Schedule a call"
    },
    // Contact
    contact: {
      title: "CONTACT",
      subtitle: "Ready to discuss your Dutch market entry?",
      form: {
        name: "Name",
        email: "Email",
        company: "Company",
        phone: "Phone",
        website: "Website",
        message: "Message",
        submit: "Send",
        success: "Thank you! Your message has been sent.",
        error: "Something went wrong. Please try again."
      }
    },
    // Quick Scan Form -> Now Intake
    quickScan: {
      title: "BOOK YOUR INTAKE CALL",
      subtitle: "Let's discuss your Dutch market ambitions in 30 minutes",
      form: {
        name: "Name",
        email: "Email",
        company: "Company",
        website: "Website URL",
        phone: "Phone (optional)",
        message: "Tell us about your Dutch market goals",
        submit: "Book Intake",
        success: "Thank you! I'll contact you within 24 hours.",
        error: "Something went wrong. Please try again."
      }
    },
    // Footer
    footer: {
      tagline: "Your SEO partner for the Dutch market",
      quickLinks: "Quick Links",
      contact: "Contact",
      email: "info@kesult.com",
      copyright: "© 2026 Kesult. All rights reserved."
    },
    // SEO Specialist Pages
    seoConsultant: {
      locationTitle: "SEO Specialist Netherlands",
      sectorTitle: "SEO for",
      challenge: "The Challenge",
      geoAdvantage: "GEO & AI Advantage",
      geoDescription: "I optimize for Answer Engines like ChatGPT and Perplexity so your brand is cited as the top expert in the Dutch market.",
      pillars: "The 3 Pillars",
      cta: "Book your Intake Call"
    },
    // Decision Tree
    decisionTree: {
      title: "WHICH PACKAGE FITS YOU?",
      start: "Start",
      question1: "Do you have internal resources (developers/writers)?",
      question2: "How complex is your target Dutch market?",
      yes: "Yes",
      no: "No",
      simple: "Local/Niche",
      medium: "Regional",
      complex: "National/Competitive",
      result: "Recommended package:",
      restart: "Start over"
    },
    // Blog
    blog: {
      title: "BLOG & INSIGHTS",
      subtitle: "Insights on Dutch SEO and market entry strategies",
      readMore: "Read more",
      back: "Back to overview"
    },
    // Common
    common: {
      learnMore: "Learn more",
      getStarted: "Get started",
      viewAll: "View all",
      loading: "Loading...",
      vanaf: "From",
      perMonth: "/month",
      perQuarter: "per quarter"
    },
    // ROI Section
    roi: {
      title: "SEO vs. Google Ads",
      subtitle: "SEO is not an expense, but an investment in the Dutch market",
      points: [
        "Own vs. Rent: With Ads you 'rent' Dutch visitors. With SEO you build your own channel.",
        "80% of Dutch searchers prefer clicking organic results over ads.",
        "5,000 extra organic visitors at €2 CPC = €10,000 ad value per month in the Netherlands."
      ]
    }
  }
};

export default translations;
